import React, { useState } from 'react';
import {  Table, Button, Card, Space, Tag, Modal, Form, Input, InputNumber, message, Popconfirm, Radio, Tooltip , Typography, Select } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
const { Title } = Typography;

// 辨识标签映射：平台=红，企业=蓝
const IDENTIFY_TAG_MAP = {
  platform: { label: '平台', color: 'red' },
  enterprise: { label: '企业', color: 'blue' },
};
const IDENTIFY_TAG_ORDER = ['platform', 'enterprise'];


const MenuConfig = () => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingKey, setEditingKey] = useState(null);

  // 模拟菜单数据：与当前项目 MainLayout menuGroups 1:1 对应
  const [data, setData] = useState([
    {
      key: '1',
      name: '平台首页',
      type: 'menu',
      path: 'home',
      icon: 'HomeOutlined',
      sort: 1,
      remark: '平台角色首页（欢迎页）',
      appLevels: ['platform', 'ent1'],
      identifyTags: ['platform'],
      children: []
    },
    {
      key: '2',
      name: '企业首页',
      type: 'menu',
      path: 'home-enterprise',
      icon: 'DashboardOutlined',
      sort: 2,
      remark: '企业数据看板（昨日运营统计）',
      appLevels: ['platform', 'ent1'],
      identifyTags: ['enterprise'],
      children: []
    },
    {
      key: '3',
      name: '产品',
      type: 'menu',
      path: 'product',
      icon: 'AppstoreOutlined',
      sort: 3,
      remark: '产品全生命周期管理',
      appLevels: ['platform', 'ent1'],
      identifyTags: ['platform', 'enterprise'],
      children: [
        {
          key: '3-1', name: '产品管理', type: 'directory', path: 'product-manage', icon: '', sort: 1, remark: '产品开发与审核', appLevels: ['platform', 'ent1'], parentId: '3',
          children: [
            { key: '3-1-1', name: '产品开发', type: 'menu', path: '/product', icon: '', sort: 1, remark: '企业侧产品开发', appLevels: ['platform', 'ent1'], parentId: '3-1' },
            { key: '3-1-2', name: '产品审核', type: 'menu', path: '/product/audit', icon: '', sort: 2, remark: '平台侧产品审核', appLevels: ['platform', 'ent1'], parentId: '3-1',
              children: [
                { key: '3-1-2-1', name: '通过审核', type: 'button', path: '', icon: '', sort: 1, remark: '审核通过操作', appLevels: ['platform', 'ent1'], parentId: '3-1-2' },
                { key: '3-1-2-2', name: '驳回审核', type: 'button', path: '', icon: '', sort: 2, remark: '审核驳回操作', appLevels: ['platform', 'ent1'], parentId: '3-1-2' }
              ] },
            { key: '3-1-3', name: '配网单元', type: 'menu', path: '/product/network-unit', icon: '', sort: 3, remark: '配网单元管理', appLevels: ['platform', 'ent1'], parentId: '3-1' },
            { key: '3-1-4', name: '生态方案库', type: 'menu', path: '/product/ecosystem', icon: '', sort: 4, remark: '生态方案列表', appLevels: ['platform', 'ent1'], parentId: '3-1' },
            { key: '3-1-5', name: '我的方案', type: 'menu', path: '/product/my-solutions', icon: '', sort: 5, remark: '企业自有方案', appLevels: ['platform', 'ent1'], parentId: '3-1' },
            { key: '3-1-6', name: '生态方案审核', type: 'menu', path: '/product/ecosystem-audit', icon: '', sort: 6, remark: '平台侧方案审核', appLevels: ['platform', 'ent1'], parentId: '3-1' }
          ]
        },
        {
          key: '3-2', name: '产品授权', type: 'directory', path: 'product-auth', icon: '', sort: 2, remark: '授权相关', appLevels: ['platform', 'ent1'], parentId: '3',
          children: [
            { key: '3-2-1', name: '授权SaaS', type: 'menu', path: '/product/authorized-saas', icon: '', sort: 1, remark: 'SaaS授权管理', appLevels: ['platform', 'ent1'], parentId: '3-2' }
          ]
        },
        {
          key: '3-3', name: '物模型', type: 'directory', path: 'thing-model', icon: '', sort: 3, remark: 'IOT核心能力管理', appLevels: ['platform', 'ent1'], parentId: '3',
          children: [
            { key: '3-3-1', name: 'IOT类目', type: 'menu', path: '/model/iot', icon: '', sort: 1, remark: '一级类目维护', appLevels: ['platform', 'ent1'], parentId: '3-3' },
            { key: '3-3-2', name: '标准能力库', type: 'menu', path: '/model/device', icon: '', sort: 2, remark: '标准物模型能力', appLevels: ['platform', 'ent1'], parentId: '3-3' },
            { key: '3-3-3', name: '自定义能力', type: 'menu', path: '/model/customdevice', icon: '', sort: 3, remark: '自定义物模型能力', appLevels: ['platform', 'ent1'], parentId: '3-3' },
            { key: '3-3-4', name: '算法库', type: 'menu', path: '/model/algorithm', icon: '', sort: 4, remark: 'AI算法管理', appLevels: ['platform', 'ent1'], parentId: '3-3' },
            { key: '3-3-5', name: '事件库', type: 'menu', path: '/model/event', icon: '', sort: 5, remark: '事件定义管理', appLevels: ['platform', 'ent1'], parentId: '3-3' }
          ]
        },
        {
          key: '3-4', name: '设备SDK', type: 'directory', path: 'device-sdk', icon: '', sort: 4, remark: '设备SDK编译服务', appLevels: ['platform', 'ent1'], parentId: '3',
          children: [
            { key: '3-4-1', name: '编译链管理', type: 'menu', path: '/compile/toolchain', icon: '', sort: 1, remark: '编译链配置', appLevels: ['platform', 'ent1'], parentId: '3-4' },
            { key: '3-4-2', name: '编译任务', type: 'menu', path: '/compile/task', icon: '', sort: 2, remark: 'SDK编译任务', appLevels: ['platform', 'ent1'], parentId: '3-4' },
            { key: '3-4-3', name: 'SDK版本管理', type: 'menu', path: '/compile/sdk-version', icon: '', sort: 3, remark: 'SDK版本维护', appLevels: ['platform', 'ent1'], parentId: '3-4' }
          ]
        }
      ]
    },
    {
      key: '4',
      name: '客户',
      type: 'menu',
      path: 'customer',
      icon: 'TeamOutlined',
      sort: 4,
      remark: '客户与分润管理',
      appLevels: ['platform', 'ent1'],
      children: [
        {
          key: '4-1', name: '我的客户', type: 'directory', path: 'my-customer', icon: '', sort: 1, remark: '客户企业管理', appLevels: ['platform', 'ent1'], parentId: '4',
          children: [
            { key: '4-1-1', name: '平台客户', type: 'menu', path: '/company/sub', icon: '', sort: 1, remark: '平台直签客户', appLevels: ['platform', 'ent1'], parentId: '4-1' },
            { key: '4-1-2', name: '合作企业', type: 'menu', path: '/company/cooperation', icon: '', sort: 2, remark: '合作企业列表', appLevels: ['platform', 'ent1'], parentId: '4-1' },
            { key: '4-1-3', name: '下级企业', type: 'menu', path: '/company/list', icon: '', sort: 3, remark: '下级企业管理', appLevels: ['platform', 'ent1'], parentId: '4-1' },
            { key: '4-1-4', name: '品牌设置', type: 'menu', path: '/company/brand', icon: '', sort: 4, remark: '品牌信息配置', appLevels: ['platform', 'ent1'], parentId: '4-1' },
            { key: '4-1-5', name: '企业信息', type: 'menu', path: '/company/info', icon: '', sort: 5, remark: '企业资料与商务配置', appLevels: ['platform', 'ent1'], parentId: '4-1' }
          ]
        },
        {
          key: '4-2', name: '客户服务', type: 'directory', path: 'customer-service', icon: '', sort: 2, remark: '客户跟进与工单', appLevels: ['platform', 'ent1'], parentId: '4',
          children: [
            { key: '4-2-1', name: '客户跟踪', type: 'menu', path: '/customer/crm', icon: '', sort: 1, remark: '客户CRM跟踪', appLevels: ['platform', 'ent1'], parentId: '4-2' },
            { key: '4-2-2', name: '客户标签', type: 'menu', path: '/customer/crm/tags', icon: '', sort: 2, remark: '客户标签管理', appLevels: ['platform', 'ent1'], parentId: '4-2' },
            { key: '4-2-3', name: '工单管理', type: 'menu', path: '/customer/ticket-manage', icon: '', sort: 3, remark: '客服工单管理', appLevels: ['platform', 'ent1'], parentId: '4-2',
              children: [
                { key: '4-2-3-1', name: '关闭工单', type: 'button', path: '', icon: '', sort: 1, remark: '关闭工单操作', appLevels: ['platform', 'ent1'], parentId: '4-2-3' },
                { key: '4-2-3-2', name: '转派工单', type: 'button', path: '', icon: '', sort: 2, remark: '工单转派操作', appLevels: ['platform', 'ent1'], parentId: '4-2-3' }
              ] },
            { key: '4-2-4', name: '客服账号', type: 'menu', path: '/customer/agent-manage', icon: '', sort: 4, remark: '客服账号管理', appLevels: ['platform', 'ent1'], parentId: '4-2' }
          ]
        },
        {
          key: '4-3', name: '设备分销', type: 'directory', path: 'device-distribution', icon: '', sort: 3, remark: '设备分销管理', appLevels: ['platform', 'ent1'], parentId: '4',
          children: [
            { key: '4-3-1', name: '我的设备分销', type: 'menu', path: '/distribution/my', icon: '', sort: 1, remark: '自有分销设备', appLevels: ['platform', 'ent1'], parentId: '4-3' },
            { key: '4-3-2', name: '代理设备分销', type: 'menu', path: '/distribution/proxy', icon: '', sort: 2, remark: '代理分销设备', appLevels: ['platform', 'ent1'], parentId: '4-3' }
          ]
        },
        {
          key: '4-4', name: '设备订单分润', type: 'directory', path: 'order-profit', icon: '', sort: 4, remark: '设备订单分润管理', appLevels: ['platform', 'ent1'], parentId: '4',
          children: [
            { key: '4-4-1', name: '底价手续费', type: 'menu', path: '/share/business-config', icon: '', sort: 1, remark: '底价与手续费配置', appLevels: ['platform', 'ent1'], parentId: '4-4' },
            { key: '4-4-2', name: 'App分润', type: 'menu', path: '/share/profit/app', icon: '', sort: 2, remark: 'App分润配置', appLevels: ['platform', 'ent1'], parentId: '4-4' },
            { key: '4-4-3', name: '分润再分配', type: 'menu', path: '/share/profit/again', icon: '', sort: 3, remark: '分润再分配', appLevels: ['platform', 'ent1'], parentId: '4-4' },
            { key: '4-4-4', name: '分润支出', type: 'menu', path: '/share/profit/expend', icon: '', sort: 4, remark: '分润支出账单', appLevels: ['platform', 'ent1'], parentId: '4-4' },
            { key: '4-4-5', name: '分润收益', type: 'menu', path: '/share/profit/income', icon: '', sort: 5, remark: '分润收益统计', appLevels: ['platform', 'ent1'], parentId: '4-4' }
          ]
        },
        {
          key: '4-5', name: '设备广告分润', type: 'directory', path: 'ad-profit', icon: '', sort: 5, remark: '广告分润管理', appLevels: ['platform', 'ent1'], parentId: '4',
          children: [
            { key: '4-5-1', name: '分润配置', type: 'menu', path: '/share/ad-profit/config', icon: '', sort: 1, remark: '广告分润配置', appLevels: ['platform', 'ent1'], parentId: '4-5' },
            { key: '4-5-2', name: '分润支出', type: 'menu', path: '/share/ad-profit/expend', icon: '', sort: 2, remark: '广告分润支出', appLevels: ['platform', 'ent1'], parentId: '4-5' },
            { key: '4-5-3', name: '分润收益', type: 'menu', path: '/share/ad-profit/income', icon: '', sort: 3, remark: '广告分润收益', appLevels: ['platform', 'ent1'], parentId: '4-5' },
            { key: '4-5-4', name: '分润再分配', type: 'menu', path: '/share/ad-profit/again', icon: '', sort: 4, remark: '广告分润再分配', appLevels: ['platform', 'ent1'], parentId: '4-5' },
            { key: '4-5-5', name: '分润监管', type: 'menu', path: '/share/ad-profit/supervise', icon: '', sort: 5, remark: '广告分润监管', appLevels: ['platform', 'ent1'], parentId: '4-5' }
          ]
        }
      ]
    },
    {
      key: '5',
      name: '设备',
      type: 'menu',
      path: 'device',
      icon: 'HddOutlined',
      sort: 5,
      remark: '设备全生命周期管理',
      appLevels: ['platform', 'ent1'],
      children: [
        {
          key: '5-1', name: '固件管理', type: 'directory', path: 'firmware', icon: '', sort: 1, remark: '固件升级管理', appLevels: ['platform', 'ent1'], parentId: '5',
          children: [
            { key: '5-1-1', name: '我的固件', type: 'menu', path: '/firmware', icon: '', sort: 1, remark: '固件列表与升级', appLevels: ['platform', 'ent1'], parentId: '5-1',
              children: [
                { key: '5-1-1-1', name: '上传固件', type: 'button', path: '', icon: '', sort: 1, remark: '上传固件操作', appLevels: ['platform', 'ent1'], parentId: '5-1-1' },
                { key: '5-1-1-2', name: '发布固件', type: 'button', path: '', icon: '', sort: 2, remark: '发布固件操作', appLevels: ['platform', 'ent1'], parentId: '5-1-1' }
              ] },
          ]
        },
        {
          key: '5-2', name: '生产管理', type: 'directory', path: 'production', icon: '', sort: 2, remark: '生产工单与产测', appLevels: ['platform', 'ent1'], parentId: '5',
          children: [
            { key: '5-2-1', name: '生产工单', type: 'menu', path: '/production/productionOrder', icon: '', sort: 1, remark: '生产工单管理', appLevels: ['platform', 'ent1'], parentId: '5-2' },
            { key: '5-2-2', name: '产测账号', type: 'menu', path: '/production/prodTestAccount', icon: '', sort: 2, remark: '产测账号管理', appLevels: ['platform', 'ent1'], parentId: '5-2' },
            { key: '5-2-3', name: 'License查询', type: 'menu', path: '/device/license-query', icon: '', sort: 3, remark: 'License查询', appLevels: ['platform', 'ent1'], parentId: '5-2' },
            { key: '5-2-4', name: '产测售后', type: 'menu', path: '/production/prodTestAfterSales', icon: '', sort: 4, remark: '产测售后处理', appLevels: ['platform', 'ent1'], parentId: '5-2' },
            { key: '5-2-5', name: '产测统计', type: 'menu', path: '/production/prodTestStatistics', icon: '', sort: 5, remark: '产测生产数据统计', appLevels: ['platform', 'ent1'], parentId: '5-2' }
          ]
        },
        {
          key: '5-3', name: '设备中心', type: 'directory', path: 'device-center', icon: '', sort: 3, remark: '设备管理运维', appLevels: ['platform', 'ent1'], parentId: '5',
          children: [
            { key: '5-3-1', name: '设备管理', type: 'menu', path: '/device/list', icon: '', sort: 1, remark: '设备列表管理', appLevels: ['platform', 'ent1'], parentId: '5-3',
              children: [
                { key: '5-3-1-1', name: '导入设备', type: 'button', path: '', icon: '', sort: 1, remark: '批量导入设备操作', appLevels: ['platform', 'ent1'], parentId: '5-3-1' },
                { key: '5-3-1-2', name: '删除设备', type: 'button', path: '', icon: '', sort: 2, remark: '删除设备操作', appLevels: ['platform', 'ent1'], parentId: '5-3-1' }
              ] },
            { key: '5-3-2', name: '设备调拨', type: 'menu', path: '/device/transfer', icon: '', sort: 2, remark: '设备调拨管理', appLevels: ['platform', 'ent1'], parentId: '5-3' },
            { key: '5-3-3', name: '固件OTA', type: 'menu', path: '/device/firmware/ota', icon: '', sort: 3, remark: '固件OTA升级', appLevels: ['platform', 'ent1'], parentId: '5-3' },
            { key: '5-3-4', name: '设备运维', type: 'menu', path: '/device/maintenance', icon: '', sort: 4, remark: '设备运维操作', appLevels: ['platform', 'ent1'], parentId: '5-3' }
          ]
        }
      ]
    },
    {
      key: '6',
      name: '应用',
      type: 'menu',
      path: 'app-service',
      icon: 'CloudServerOutlined',
      sort: 6,
      remark: '应用与SaaS服务',
      appLevels: ['platform', 'ent1'],
      children: [
        {
          key: '6-1', name: 'App', type: 'directory', path: 'app-manage', icon: '', sort: 1, remark: 'App应用管理', appLevels: ['platform', 'ent1'], parentId: '6',
          children: [
            { key: '6-1-1', name: '我的App', type: 'menu', path: '/app/manage', icon: '', sort: 1, remark: '企业自有App', appLevels: ['platform', 'ent1'], parentId: '6-1',
              children: [
                { key: '6-1-1-1', name: '发布App', type: 'button', path: '', icon: '', sort: 1, remark: '发布App操作', appLevels: ['platform', 'ent1'], parentId: '6-1-1' },
                { key: '6-1-1-2', name: '下线App', type: 'button', path: '', icon: '', sort: 2, remark: '下线App操作', appLevels: ['platform', 'ent1'], parentId: '6-1-1' }
              ] },
            { key: '6-1-2', name: '待审核App', type: 'menu', path: '/app/audit', icon: '', sort: 2, remark: 'App审核队列', appLevels: ['platform', 'ent1'], parentId: '6-1' },
            { key: '6-1-3', name: '管理App', type: 'menu', path: '/app/audit/manage', icon: '', sort: 3, remark: 'App管理', appLevels: ['platform', 'ent1'], parentId: '6-1' },
            { key: '6-1-4', name: '平台商户号', type: 'menu', path: '/app/merchant-platform', icon: '', sort: 4, remark: '平台商户号管理', appLevels: ['platform', 'ent1'], parentId: '6-1' },
            { key: '6-1-5', name: '企业商户号', type: 'menu', path: '/app/merchant-enterprise', icon: '', sort: 5, remark: '企业商户号管理', appLevels: ['platform', 'ent1'], parentId: '6-1' }
          ]
        },
        {
          key: '6-2', name: '私有化部署', type: 'directory', path: 'private-deploy', icon: '', sort: 2, remark: '私有化部署服务', appLevels: ['platform', 'ent1'], parentId: '6',
          children: [
            { key: '6-2-1', name: '我的私有部署', type: 'menu', path: '/app/private-deploy', icon: '', sort: 1, remark: '企业私有部署', appLevels: ['platform', 'ent1'], parentId: '6-2' },
            { key: '6-2-2', name: '私有部署管理', type: 'menu', path: '/app/private-deploy-audit', icon: '', sort: 2, remark: '私有部署审核管理', appLevels: ['platform', 'ent1'], parentId: '6-2' }
          ]
        },
        {
          key: '6-3', name: 'SaaS应用', type: 'directory', path: 'saas-app', icon: '', sort: 3, remark: 'SaaS应用服务', appLevels: ['platform', 'ent1'], parentId: '6',
          children: [
            { key: '6-3-1', name: '我的SaaS', type: 'menu', path: '/app/self-saas', icon: '', sort: 1, remark: '企业SaaS应用', appLevels: ['platform', 'ent1'], parentId: '6-3' },
            { key: '6-3-2', name: 'SaaS审核', type: 'menu', path: '/app/saas-audit', icon: '', sort: 2, remark: 'SaaS审核管理', appLevels: ['platform', 'ent1'], parentId: '6-3' }
          ]
        }
      ]
    },
    {
      key: '7',
      name: '运营',
      type: 'menu',
      path: 'operation',
      icon: 'ControlOutlined',
      sort: 7,
      remark: '运营与商业化配置',
      appLevels: ['platform', 'ent1'],
      children: [
        {
          key: '7-1', name: 'Agent工厂', type: 'directory', path: 'agent-factory', icon: '', sort: 1, remark: 'AI Agent管理', appLevels: ['platform', 'ent1'], parentId: '7',
          children: [
            { key: '7-1-1', name: '模型管理', type: 'menu', path: '/agent/models', icon: '', sort: 1, remark: 'AI模型管理', appLevels: ['platform', 'ent1'], parentId: '7-1' },
            { key: '7-1-2', name: '触发事件管理', type: 'menu', path: '/agent/events', icon: '', sort: 2, remark: 'Agent触发事件', appLevels: ['platform', 'ent1'], parentId: '7-1' },
            { key: '7-1-3', name: 'Agent管理', type: 'menu', path: '/agent/list', icon: '', sort: 3, remark: 'Agent列表管理', appLevels: ['platform', 'ent1'], parentId: '7-1' }
          ]
        },
        {
          key: '7-2', name: '流量卡', type: 'directory', path: 'flow-card', icon: '', sort: 2, remark: '4G流量卡管理', appLevels: ['platform', 'ent1'], parentId: '7',
          children: [
            { key: '7-2-1', name: '卡商定义', type: 'menu', path: '/4g/cardDefinition', icon: '', sort: 1, remark: '卡商定义维护', appLevels: ['platform', 'ent1'], parentId: '7-2' },
            { key: '7-2-2', name: '卡商管理', type: 'menu', path: '/4g/cardDealerConfig', icon: '', sort: 2, remark: '卡商配置管理', appLevels: ['platform', 'ent1'], parentId: '7-2' },
            { key: '7-2-3', name: '4G卡管理', type: 'menu', path: '/4g/cardConfig', icon: '', sort: 3, remark: '4G卡列表管理', appLevels: ['platform', 'ent1'], parentId: '7-2' }
          ]
        },
        {
          key: '7-3', name: '套餐管理', type: 'directory', path: 'package-manage', icon: '', sort: 3, remark: '套餐服务配置', appLevels: ['platform', 'ent1'], parentId: '7',
          children: [
            { key: '7-3-1', name: '服务类型', type: 'menu', path: '/package/service', icon: '', sort: 1, remark: '服务类型维护', appLevels: ['platform', 'ent1'], parentId: '7-3' },
            { key: '7-3-2', name: '套餐服务管理', type: 'menu', path: '/package/template', icon: '', sort: 2, remark: '套餐服务配置', appLevels: ['platform', 'ent1'], parentId: '7-3' },
            { key: '7-3-3', name: '套餐配置', type: 'menu', path: '/package/app-package', icon: '', sort: 3, remark: 'App套餐配置', appLevels: ['platform', 'ent1'], parentId: '7-3',
              children: [
                { key: '7-3-3-1', name: '上架套餐', type: 'button', path: '', icon: '', sort: 1, remark: '套餐上架操作', appLevels: ['platform', 'ent1'], parentId: '7-3-3' },
                { key: '7-3-3-2', name: '下架套餐', type: 'button', path: '', icon: '', sort: 2, remark: '套餐下架操作', appLevels: ['platform', 'ent1'], parentId: '7-3-3' }
              ] },
            { key: '7-3-4', name: '赠送套餐', type: 'menu', path: '/package/gift', icon: '', sort: 4, remark: '赠送套餐管理', appLevels: ['platform', 'ent1'], parentId: '7-3' },
            { key: '7-3-5', name: '超管开关套餐', type: 'menu', path: '/package/admin', icon: '', sort: 5, remark: '超管套餐开关', appLevels: ['platform', 'ent1'], parentId: '7-3' },
            { key: '7-3-6', name: '套餐转移', type: 'menu', path: '/package/transfer', icon: '', sort: 6, remark: '套餐转移管理', appLevels: ['platform', 'ent1'], parentId: '7-3' }
          ]
        },
        {
          key: '7-4', name: '套餐售卖', type: 'directory', path: 'package-sale', icon: '', sort: 4, remark: '套餐售卖位运营', appLevels: ['platform', 'ent1'], parentId: '7',
          children: [
            { key: '7-4-1', name: '商城位运营', type: 'menu', path: '/operation/mall', icon: '', sort: 1, remark: '商城位运营管理', appLevels: ['platform', 'ent1'], parentId: '7-4' },
            { key: '7-4-2', name: '推荐位运营', type: 'menu', path: '/operation/recommend', icon: '', sort: 2, remark: '推荐位运营管理', appLevels: ['platform', 'ent1'], parentId: '7-4' },
            { key: '7-4-3', name: '自定义售卖', type: 'menu', path: '/operation/custom-sale', icon: '', sort: 3, remark: '企业自定义售卖位置与套餐清单', appLevels: ['platform', 'ent1'], parentId: '7-4' }
          ]
        },
        {
          key: '7-5', name: '用户画像', type: 'directory', path: 'user-portrait', icon: '', sort: 5, remark: '用户画像分析', appLevels: ['platform', 'ent1'], parentId: '7',
          children: [
            { key: '7-5-1', name: '用户分群', type: 'menu', path: '/operation/user-segment', icon: '', sort: 1, remark: '用户分群管理', appLevels: ['platform', 'ent1'], parentId: '7-5' }
          ]
        },
        {
          key: '7-6', name: '广告投放', type: 'directory', path: 'ad-delivery', icon: '', sort: 6, remark: '广告投放管理', appLevels: ['platform', 'ent1'], parentId: '7',
          children: [
            { key: '7-6-1', name: '广告配置管理', type: 'menu', path: '/operation/ad-slot', icon: '', sort: 1, remark: '广告位配置', appLevels: ['platform', 'ent1'], parentId: '7-6' },
            { key: '7-6-2', name: '广告投放策略', type: 'menu', path: '/operation/ad-strategy', icon: '', sort: 2, remark: '广告策略管理', appLevels: ['platform', 'ent1'], parentId: '7-6' },
            { key: '7-6-3', name: '精准广告策略', type: 'menu', path: '/ad/whitelist', icon: '', sort: 3, remark: '精准广告策略管理', appLevels: ['platform', 'ent1'], parentId: '7-6' }
          ]
        }
      ]
    },
    {
      key: '8',
      name: '账务',
      type: 'menu',
      path: 'finance',
      icon: 'AccountBookOutlined',
      sort: 8,
      remark: '订单与账务管理',
      appLevels: ['platform', 'ent1'],
      children: [
        {
          key: '8-1', name: '采购订单', type: 'directory', path: 'purchase-order', icon: '', sort: 1, remark: '生产采购订单', appLevels: ['platform', 'ent1'], parentId: '8',
          children: [
            { key: '8-1-1', name: '生产授权采购', type: 'menu', path: '/order/production/auth', icon: '', sort: 1, remark: '生产授权采购订单', appLevels: ['platform', 'ent1'], parentId: '8-1' },
            { key: '8-1-2', name: '企业生产采购', type: 'menu', path: '/order/company/production', icon: '', sort: 2, remark: '企业生产采购订单', appLevels: ['platform', 'ent1'], parentId: '8-1' }
          ]
        },
        {
          key: '8-2', name: '增值订单', type: 'directory', path: 'value-order', icon: '', sort: 2, remark: '增值服务订单', appLevels: ['platform', 'ent1'], parentId: '8',
          children: [
            { key: '8-2-1', name: '增值服务订单', type: 'menu', path: '/order/services', icon: '', sort: 1, remark: '增值服务订单列表', appLevels: ['platform', 'ent1'], parentId: '8-2' },
            { key: '8-2-2', name: '4G流量订单', type: 'menu', path: '/order/4g', icon: '', sort: 2, remark: '4G流量订单列表', appLevels: ['platform', 'ent1'], parentId: '8-2' }
          ]
        },
        {
          key: '8-3', name: '费用中心', type: 'directory', path: 'cost-center', icon: '', sort: 3, remark: '账户与发票', appLevels: ['platform', 'ent1'], parentId: '8',
          children: [
            { key: '8-3-1', name: '消费账户', type: 'menu', path: '/cost/consumption/account', icon: '', sort: 1, remark: '消费账户管理', appLevels: ['platform', 'ent1'], parentId: '8-3' },
            { key: '8-3-2', name: '收益账户', type: 'menu', path: '/cost/income', icon: '', sort: 2, remark: '收益账户管理', appLevels: ['platform', 'ent1'], parentId: '8-3' },
            { key: '8-3-3', name: '发票管理', type: 'menu', path: '/cost/invoices', icon: '', sort: 3, remark: '发票中心管理', appLevels: ['platform', 'ent1'], parentId: '8-3',
              children: [
                { key: '8-3-3-1', name: '申请开票', type: 'button', path: '', icon: '', sort: 1, remark: '申请开票操作', appLevels: ['platform', 'ent1'], parentId: '8-3-3' }
              ] }
          ]
        },
        {
          key: '8-4', name: '平台账务', type: 'directory', path: 'platform-finance', icon: '', sort: 4, remark: '平台财务操作', appLevels: ['platform', 'ent1'], parentId: '8',
          children: [
            { key: '8-4-1', name: '充值审核', type: 'menu', path: '/finance/rechargAudit', icon: '', sort: 1, remark: '充值审核管理', appLevels: ['platform', 'ent1'], parentId: '8-4',
              children: [
                { key: '8-4-1-1', name: '通过审核', type: 'button', path: '', icon: '', sort: 1, remark: '充值审核通过', appLevels: ['platform', 'ent1'], parentId: '8-4-1' },
                { key: '8-4-1-2', name: '驳回审核', type: 'button', path: '', icon: '', sort: 2, remark: '充值审核驳回', appLevels: ['platform', 'ent1'], parentId: '8-4-1' }
              ] },
            { key: '8-4-2', name: '生产授权直充', type: 'menu', path: '/finance/direct-topup', icon: '', sort: 2, remark: '生产授权直充', appLevels: ['platform', 'ent1'], parentId: '8-4' },
            { key: '8-4-3', name: '信用额度', type: 'menu', path: '/finance/creditLimit', icon: '', sort: 3, remark: '信用额度管理', appLevels: ['platform', 'ent1'], parentId: '8-4' },
            { key: '8-4-4', name: '汇率管理', type: 'menu', path: '/finance/exchangeRate', icon: '', sort: 4, remark: '汇率配置管理', appLevels: ['platform', 'ent1'], parentId: '8-4' },
            { key: '8-4-5', name: '发票管理', type: 'menu', path: '/finance/invoice', icon: '', sort: 5, remark: '平台发票管理', appLevels: ['platform', 'ent1'], parentId: '8-4' },
            { key: '8-4-6', name: '提现审核', type: 'menu', path: '/finance/withdrawal/audit', icon: '', sort: 6, remark: '提现审核管理', appLevels: ['platform', 'ent1'], parentId: '8-4' },
            { key: '8-4-7', name: '抽佣账单', type: 'menu', path: '/finance/commission/order', icon: '', sort: 7, remark: '平台抽佣账单', appLevels: ['platform', 'ent1'], parentId: '8-4' }
          ]
        }
      ]
    },
    {
      key: '9',
      name: '其他',
      type: 'menu',
      path: 'other',
      icon: 'MoreOutlined',
      sort: 9,
      remark: '客服、调度、系统管理',
      appLevels: ['platform', 'ent1'],
      children: [
        {
          key: '9-1', name: '客服工具', type: 'directory', path: 'customer-tool', icon: '', sort: 1, remark: '客服辅助工具', appLevels: ['platform', 'ent1'], parentId: '9',
          children: [
            { key: '9-1-1', name: '增值订单查询', type: 'menu', path: '/customer/order-query', icon: '', sort: 1, remark: '增值订单查询', appLevels: ['platform', 'ent1'], parentId: '9-1' },
            { key: '9-1-2', name: '我的工单', type: 'menu', path: '/customer/ticket/my', icon: '', sort: 2, remark: '企业侧工单', appLevels: ['platform', 'ent1'], parentId: '9-1' },
            { key: '9-1-3', name: '客服系统', type: 'menu', path: '/customer/service-system', icon: '', sort: 3, remark: '客服系统入口', appLevels: ['platform', 'ent1'], parentId: '9-1' }
          ]
        },
        {
          key: '9-2', name: '全球调度', type: 'directory', path: 'global-dispatch', icon: '', sort: 2, remark: '区域与调度管理', appLevels: ['platform', 'ent1'], parentId: '9',
          children: [
            { key: '9-2-1', name: '服务区域', type: 'menu', path: '/dispatch/serviceRegion', icon: '', sort: 1, remark: '服务区域维护', appLevels: ['platform', 'ent1'], parentId: '9-2' },
            { key: '9-2-2', name: '产品调度', type: 'menu', path: '/dispatch/product', icon: '', sort: 2, remark: '产品调度管理', appLevels: ['platform', 'ent1'], parentId: '9-2' },
            { key: '9-2-3', name: '设备调度', type: 'menu', path: '/dispatch/device', icon: '', sort: 3, remark: '设备调度管理', appLevels: ['platform', 'ent1'], parentId: '9-2' }
          ]
        },
        {
          key: '9-3', name: '日志审计', type: 'directory', path: 'audit-log', icon: '', sort: 3, remark: '平台操作审计', appLevels: ['platform', 'ent1'], parentId: '9',
          children: [
            { key: '9-3-1', name: '平台日志', type: 'menu', path: '/audit-log/platform', icon: '', sort: 1, remark: '平台日志查询', appLevels: ['platform', 'ent1'], parentId: '9-3' },
            { key: '9-3-2', name: '操作日志', type: 'menu', path: '/audit-log', icon: '', sort: 2, remark: '操作日志查询', appLevels: ['platform', 'ent1'], parentId: '9-3' }
          ]
        },
        {
          key: '9-4', name: '系统设置', type: 'directory', path: 'super-admin', icon: '', sort: 4, remark: '系统基础设施配置', appLevels: ['platform', 'ent1'], parentId: '9',
          children: [
            { key: '9-4-1', name: '菜单配置', type: 'menu', path: '/root/menu', icon: '', sort: 1, remark: '管理平台菜单', appLevels: ['platform', 'ent1'], parentId: '9-4',
              children: [
                { key: '9-4-1-1', name: '新增菜单', type: 'button', path: '', icon: '', sort: 1, remark: '新增菜单操作', appLevels: ['platform', 'ent1'], parentId: '9-4-1' },
                { key: '9-4-1-2', name: '编辑菜单', type: 'button', path: '', icon: '', sort: 2, remark: '编辑菜单操作', appLevels: ['platform', 'ent1'], parentId: '9-4-1' },
                { key: '9-4-1-3', name: '删除菜单', type: 'button', path: '', icon: '', sort: 3, remark: '删除菜单操作', appLevels: ['platform', 'ent1'], parentId: '9-4-1' }
              ] },
            { key: '9-4-2', name: '企业角色', type: 'menu', path: '/companyRole', icon: '', sort: 2, remark: '企业角色管理', appLevels: ['platform', 'ent1'], parentId: '9-4',
              children: [
                { key: '9-4-2-1', name: '新增角色', type: 'button', path: '', icon: '', sort: 1, remark: '新增角色操作', appLevels: ['platform', 'ent1'], parentId: '9-4-2' },
                { key: '9-4-2-2', name: '编辑角色', type: 'button', path: '', icon: '', sort: 2, remark: '编辑角色操作', appLevels: ['platform', 'ent1'], parentId: '9-4-2' },
                { key: '9-4-2-3', name: '删除角色', type: 'button', path: '', icon: '', sort: 3, remark: '删除角色操作', appLevels: ['platform', 'ent1'], parentId: '9-4-2' }
              ] },
            { key: '9-4-3', name: '企业账号管理', type: 'menu', path: '/companyAdmin', icon: '', sort: 3, remark: '企业账号与角色管理', appLevels: ['platform', 'ent1'], parentId: '9-4' },
            { key: '9-4-4', name: '发版公告', type: 'menu', path: '/release-notes', icon: '', sort: 4, remark: '发版公告管理', appLevels: ['platform', 'ent1'], parentId: '9-4' }
          ]
        },
        {
          key: '9-5', name: '权限管理', type: 'directory', path: 'permission-manage', icon: '', sort: 5, remark: '内部权限管理', appLevels: ['platform', 'ent1'], parentId: '9',
          children: [
            { key: '9-5-1', name: '内部角色', type: 'menu', path: '/insideRole', icon: '', sort: 1, remark: '内部角色管理', appLevels: ['platform', 'ent1'], parentId: '9-5' },
            { key: '9-5-2', name: '内部账号', type: 'menu', path: '/insideAccount', icon: '', sort: 2, remark: '内部账号管理', appLevels: ['platform', 'ent1'], parentId: '9-5' }
          ]
        }
      ]
    }
  ]);

  const showModal = (record = null, parentId = null) => {
    if (record) {
      setEditingKey(record.key);
      
      // 查找父级菜单名称用于展示
      let parentName = '无';
      if (record.parentId) {
        const findParent = (list) => {
          for (const item of list) {
            if (item.key === record.parentId) return item;
            if (item.children) {
              const res = findParent(item.children);
              if (res) return res;
            }
          }
          return null;
        };
        const parent = findParent(data);
        parentName = parent?.name || '无';
      }

      form.setFieldsValue({
        ...record,
        displayParentName: parentName,
      });
    } else {
      setEditingKey(null);
      form.resetFields();
      
      let parentName = '无';
      if (parentId) {
        const findParent = (list) => {
          for (const item of list) {
            if (item.key === parentId) return item;
            if (item.children) {
              const res = findParent(item.children);
              if (res) return res;
            }
          }
          return null;
        };
        const parent = findParent(data);
        parentName = parent?.name || '无';
      }

      form.setFieldsValue({ 
        parentId, 
        displayParentName: parentName,
        sort: 1, 
        type: 'menu' 
      });
    }
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const newData = JSON.parse(JSON.stringify(data));

      // 仅「菜单」类型可配置辨识标签，其余类型清空
      if (values.type !== 'menu') {
        delete values.identifyTags;
      }

      if (editingKey) {
        const updateItem = (list) => {
          for (let i = 0; i < list.length; i++) {
            if (list[i].key === editingKey) {
              list[i] = { ...list[i], ...values };
              return true;
            }
            if (list[i].children && updateItem(list[i].children)) return true;
          }
        };
        updateItem(newData);
        message.success('修改成功');
      } else {
        const newItem = {
          key: Date.now().toString(),
          ...values,
          children: values.type === 'button' ? null : []
        };
        
        if (!values.parentId) {
          newData.push(newItem);
        } else {
          const addItem = (list) => {
            for (let i = 0; i < list.length; i++) {
              if (list[i].key === values.parentId) {
                list[i].children = [...(list[i].children || []), newItem];
                return true;
              }
              if (list[i].children && addItem(list[i].children)) return true;
            }
          };
          addItem(newData);
        }
        message.success('新增成功');
      }
      
      setData(newData);
      setIsModalOpen(false);
    } catch (error) {
      console.log('Validate Failed:', error);
    }
  };

  const handleDelete = (key) => {
    const newData = JSON.parse(JSON.stringify(data));
    const removeItem = (list) => {
      for (let i = 0; i < list.length; i++) {
        if (list[i].key === key) {
          list.splice(i, 1);
          return true;
        }
        if (list[i].children && removeItem(list[i].children)) return true;
      }
    };
    removeItem(newData);
    setData(newData);
    message.success('删除成功');
  };

  const handleSyncRoleMenu = () => {
    Modal.confirm({
      type: 'warning',
      title: '同步角色菜单',
      content: '此功能通常使用在菜单结构调整后，对角色已配置的菜单权限丢失展示的补齐，若菜单未配置尽可能不要使用此功能',
      okText: '确认同步',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => {
        // TODO: 联调时替换为接口数据
        message.success('角色菜单同步成功');
      },
    });
  };

  const columns = [
    { 
      title: '菜单名称', 
      dataIndex: 'name', 
      key: 'name', 
      width: '30%',
      render: (text, record) => (
        <Space>
          {record.icon ? React.createElement(require('@ant-design/icons')[record.icon] || (() => null)) : null}
          <span>{text}</span>
        </Space>
      )
    },
    { 
      title: '类型', 
      dataIndex: 'type', 
      key: 'type', 
      width: '10%',
      render: (type) => {
        const config = type === 'button' 
          ? { color: 'orange', label: '按钮/操作' }
          : type === 'directory'
            ? { color: 'blue', label: '目录' }
            : { color: 'green', label: '菜单' };
        return <Tag color={config.color}>{config.label}</Tag>;
      }
    },
    { title: '菜单key', dataIndex: 'path', key: 'path', width: '15%' },
    { 
      title: '显示排序', 
      dataIndex: 'sort', 
      key: 'sort', 
      width: '10%', 
      align: 'center',
      sorter: (a, b) => a.sort - b.sort,
    },
    {
      title: '是否展示',
      dataIndex: 'appLevels',
      key: 'appLevels',
      width: '10%',
      align: 'center',
      render: (appLevels) => (
        appLevels && appLevels.length > 0
          ? <Tag color="green">展示</Tag>
          : <Tag color="red">不展示</Tag>
      ),
    },
    {
      title: '辨识标签',
      dataIndex: 'identifyTags',
      key: 'identifyTags',
      width: '12%',
      align: 'center',
      render: (tags, record) => {
        if (record.type !== 'menu' || !tags || tags.length === 0) {
          return <span style={{ color: '#ccc' }}>-</span>;
        }
        return (
          <Space size={4}>
            {IDENTIFY_TAG_ORDER.filter((v) => tags.includes(v)).map((v) => {
              const conf = IDENTIFY_TAG_MAP[v];
              return <Tag key={v} color={conf.color}>{conf.label}</Tag>;
            })}
          </Space>
        );
      },
    },
    { title: '备注', dataIndex: 'remark', key: 'remark', width: '15%', align: 'center' },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      render: (_, record) => (
        <Space size="small">
          {record.type !== 'button' && (
            <Button type="link" size="small" onClick={() => showModal(null, record.key)}>添加子类</Button>
          )}
          <Button type="link" icon={<EditOutlined />} onClick={() => showModal(record)}>编辑</Button>
          {record.children && record.children.length > 0 ? (
            <Tooltip title="存在子菜单，不可删除">
              <Button type="link" danger icon={<DeleteOutlined />} disabled>删除</Button>
            </Tooltip>
          ) : (
            <Popconfirm
              title="确定要删除该菜单吗？"
              onConfirm={() => handleDelete(record.key)}
              okText="确定"
              cancelText="取消"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            >
              <Button type="link" danger icon={<DeleteOutlined />}>删除</Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>菜单配置</Title>
      </div>
      <Card 
        // title="菜单配置" 
        bordered={false}
      >
        <div style={{ marginBottom: 16 }}>
          <Space>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
              新增菜单
            </Button>
            <Button color="gold" variant="solid" onClick={handleSyncRoleMenu}>
              同步角色菜单
            </Button>
          </Space>
        </div>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="key"
          expandable={{ defaultExpandAllRows: true }}
        />
      </Card>

      <Modal
        title={editingKey ? '编辑菜单' : '新增菜单'}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
        okText="保存"
        cancelText="取消"
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          style={{ marginTop: 16 }}
        >
          <Form.Item name="parentId" hidden><Input /></Form.Item>
          <Form.Item name="displayParentName" label="上级菜单">
            <Input disabled style={{ backgroundColor: '#f5f5f5' }} />
          </Form.Item>
          <Form.Item
            name="name"
            label="菜单名称"
            rules={[{ required: true, message: '请输入菜单名称' }]}
          >
            <Input placeholder="例如：用户管理" />
          </Form.Item>
          
          <Form.Item noStyle shouldUpdate={(p, c) => p.parentId !== c.parentId}>
            {({ getFieldValue, setFieldsValue }) => {
              const isTopLevel = !getFieldValue('parentId');
              return (
                <Form.Item
                  name="type"
                  label="类型"
                  rules={[{ required: true, message: '请选择节点类型' }]}
                >
                  <Radio.Group 
                    disabled={isTopLevel && !editingKey}
                    onChange={(e) => {
                      if (e.target.value === 'button') {
                        const parentAppLevels = getFieldValue('parentAppLevels');
                        if (parentAppLevels) {
                          setFieldsValue({ appLevels: parentAppLevels });
                        }
                      }
                    }}
                  >
                    <Radio value="directory">目录</Radio>
                    <Radio value="menu">菜单</Radio>
                    <Radio value="button">按钮/操作</Radio>
                  </Radio.Group>
                </Form.Item>
              );
            }}
          </Form.Item>

          <Form.Item name="parentAppLevels" hidden><Input /></Form.Item>
          
          <Form.Item noStyle shouldUpdate={(p, c) => p.type !== c.type}>
            {({ getFieldValue }) => {
              const type = getFieldValue('type');
              if (type === 'button') return null;
              return (
                <Form.Item
                  name="path"
                  label="菜单key"
                  rules={[{ required: true, message: '请输入菜单key' }]}
                >
                  <Input placeholder="例如：system_user" />
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(p, c) => p.type !== c.type}>
            {({ getFieldValue }) => {
              const type = getFieldValue('type');
              if (type !== 'menu') return null;
              return (
                <Form.Item name="identifyTags" label="辨识标签">
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="请选择辨识标签（可复选）"
                    options={IDENTIFY_TAG_ORDER.map((v) => ({ value: v, label: IDENTIFY_TAG_MAP[v].label }))}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item name="icon" label="菜单图标">
            <Input placeholder="Ant Design 图标名，例如：UserOutlined" />
          </Form.Item>
          <Form.Item name="sort" label="显示排序">
            <InputNumber min={1} style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="remark" label="备注">
            <Input placeholder="请输入备注" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MenuConfig;
